import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faAngellist } from "@fortawesome/free-brands-svg-icons/faAngellist";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
import { faSnapchatGhost } from "@fortawesome/free-brands-svg-icons";
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: "https://github.com/joshex150",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.facebook.com/Joshex15",
    label: "Facebook",
    icon: faFacebookF,
  },
  {
    link: "https://www.instagram.com/fw.kachi",
    label: "Instagram",
    icon: faInstagram,
  },
  {
    link: "https://www.linkedin.com/in/yelekachi",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://t.snapchat.com/wTm0GFTR",
    label: "Snapchat",
    icon: faSnapchatGhost,
  },
  {
    link: "mailto:joshex150@gmail.com",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
